import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface FloatingLabelSelectProps {
  label: string;
  value: string;
  onValueChange: (value: string) => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const FloatingLabelSelect: React.FC<FloatingLabelSelectProps> = ({ label, value, onValueChange, children, className, style }) => {
  const hasValue = value && value.length > 0;

  const labelClasses = `absolute left-3 transition-all duration-200 ease-in-out pointer-events-none 
    ${hasValue ? 'top-2 text-xs text-blue-600 dark:text-blue-400' : 'top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400'}`;

  return (
    <div className="relative">
        <Select value={value} onValueChange={onValueChange}>
            <SelectTrigger 
              className={className || "w-full bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-700 h-14 pt-6 text-slate-900 dark:text-white"}
              style={style}
            >
                <SelectValue className={className ? "text-inherit" : ""} />
            </SelectTrigger>
            <SelectContent className="bg-white dark:bg-gray-950 text-slate-900 dark:text-white border-gray-300 dark:border-gray-800">
                {children}
            </SelectContent>
        </Select>
        {!className && (
          <label className={labelClasses}>
              {label}
          </label>
        )}
    </div>
  );
};

export default FloatingLabelSelect;
